import { NavLink, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { MdSpaceDashboard } from "react-icons/md";
import { FaBook, FaClock } from "react-icons/fa";
import { IoSettingsSharp } from "react-icons/io5";
import { useState } from "react";
import './sidebar.css';

const routes = [
  { path: "/team-chart", name: "Hirearchy", icon: <MdSpaceDashboard /> },
  { path: "/handbook", name: "HiraLab HandBook", icon: <FaBook /> },
  { path: "/time-history", name: "My Timing History", icon: <FaClock />, subRoutes: [{ path: "/timings-history" }] },
  { path: "/account-settings", name: "Account Settings", icon: <IoSettingsSharp />, subRoutes: [{ path: "/reset-password" }] },
];

const SideBar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleSidebar = () => setIsOpen(!isOpen);

  const handleLinkClick = () => {
    if (window.innerWidth <= 1024) setIsOpen(false);
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <div className="sidebar-container">
      {/* Hamburger Button */}
      <button className="hamburger" onClick={toggleSidebar} aria-label="Toggle Menu">
        <FaBars />
      </button>

      {/* Sidebar Menu */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <section className="routes">
          {routes.map((route, index) => {
            const isRouteActive = isActive(route.path) || (route.subRoutes && route.subRoutes.some((subRoute) => isActive(subRoute.path)));
            return (
              <NavLink
                to={route.path}
                key={index}
                className={`link ${isRouteActive ? "active" : ""}`}
                onClick={handleLinkClick}
              >
                <div className="icon">{route.icon}</div>
                <div className="link_text">{route.name}</div>
              </NavLink>
            );
          })}
        </section>
      </div>
    </div>
  );
};

export default SideBar;